import { CircularProgress, Stack, SxProps } from "@mui/material";
import React, { FC } from "react";
import { useSxMerge } from "shared-ts-mui";

export interface CenteredCircularProgressProps {
  sx?: SxProps;
}

export const CenteredCircularProgress: FC<CenteredCircularProgressProps> = (
  props
) => {
  const sx = useSxMerge(
    {
      flexGrow: 1,
      minWidth: 0,
      minHeight: 0,
      width: "100vw",
      height: "100vh",
      alignItems: "center",
      justifyContent: "center",
    },
    props.sx
  );

  return (
    <Stack sx={sx}>
      <CircularProgress />
    </Stack>
  );
};
